import Chart from './Model/Chart';
import config from './config';

requirejs(['jquery'], function($) {
    const apiBase = config.apiUrl + '/v2/chart/';

    $('.js-change-period').on('click', function(){
        const dom = $(this).parents('.visualization:first');
        const chart = dom.find('.chart:first');
        const button = $(this);
        const period = button.attr('data-period');
        const buttonsContainer = $(this).parent();

        const code = chart.attr('data-code');
        const type = chart.attr('data-type');

        buttonsContainer.find('.js-current').removeClass('js-current');
        button.addClass('js-current');

        const url = apiBase + type + '/' + code + '?last=' + period;

        const updateName = data => {
            const newName = data[data.length - 1].name;
            const node = dom.find('.js-name');
            const currentName = parseFloat(node.html());
            const counter = { var: currentName };

            TweenMax.to(counter, 1, {
                var: newName,
                onUpdate: function () {
                    node.html(counter.var);
                },
                ease: Circ.easeOut
            });
        };

        const updateValue = data => {
            const newValue = data[data.length - 1].line;
            const node = dom.find('.js-value');
            const currentValue = parseFloat(node.html());
            const counter = { var: currentValue };

            TweenMax.to(counter, 1, {
                var: newValue,
                onUpdate: function () {
                    node.html( Math.round(counter.var * 10000) / 10000);
                    // node.html(counter.var);
                },
                ease: Circ.easeOut
            });
        };

        const updateUnit = data => {
            const newUnit = ' (' + data[0].unit + ')'
            const node = dom.find('.js-unit');
            const currentUnit = parseFloat(node.html());
            const counter = { var: currentUnit };

            TweenMax.to(counter, 1, {
                var: newUnit,
                onUpdate: function () {
                    node.html(counter.var);
                },
                ease: Circ.easeOut
            });
        };

        const updatePercentage = (data) => {
            const previous = data[0].line;
            const current = data[data.length-1].line;
            const node = dom.find('.js-change');
            const currentValue = parseFloat(node.html());
            const newValue = (current / previous - 1) * 100;

            const counter = { var: currentValue };

            TweenMax.to(counter, 1, {
                var: newValue,
                onUpdate: function () {
                    const percentageChange = counter.var.toFixed(2);
                    let tendention = 'neutral';

                    if (percentageChange < 0) {
                        tendention = 'down';
                    } else if (percentageChange > 0) {
                        tendention = 'up';
                    }

                    node.html(counter.var.toFixed(2));
                    node.parent().attr('data-tendention', tendention);
                },
                ease:Circ.easeOut
            });
        };

        const chartObject = Chart.getChart(chart.attr('id'));

        $.ajax({
            url: url,
            success: (json) => {
                chartObject.applyData(json.data);
                updateName(json.data);
                updateValue(json.data);
                updateUnit(json.data);
                updatePercentage(json.data);
            }
        })
    });

    $('.chart-navigation').each(function() {
        $(this).find('.js-change-period:eq(0)').trigger('click');
    })
});



// WEBPACK FOOTER //
// ./js/ui.js